<template>
  <HealthFrame v-slot="{ error, forLabel }" v-bind="$attrs">
    <component :is="icon ? HealthIconField : 'div'" v-bind="icon ? { icon } : {}">
      <InputText
        :id="forLabel"
        ref="primeInputRef"
        v-bind="props"
        v-model="modelValue"
        fluid
        :autofocus="autofocus"
        :invalid="error"
      />
    </component>
  </HealthFrame>
</template>

<script setup lang="ts">
  import { ref } from "vue";
  import InputText from "primevue/inputtext";
  import HealthIconField from "@/shared/components/form/HealthIconField.vue";
  import HealthFrame from "@/shared/components/form/HealthFrame.vue";
  import type { InputProps } from "@/shared/components/form/input_text/props.ts";

  const primeInputRef = ref(null);

  type Props = Omit<InputProps, "modelValue" | "error" | "forLabel"> & {};

  const modelValue = defineModel();

  const props = withDefaults(defineProps<Props>(), {
    size: "small",
    autofocus: false,
  });

  defineExpose({
    focus: () => {
      primeInputRef.value?.$el.focus();
    },
  });
</script>
